// extracted by mini-css-extract-plugin
export default {"cashierBanner":"ShoppingCartCheckoutPage_cashierBanner__3M9bW"};